<template>
    <BaseCard padding="none" elevated class="overflow-hidden text-ink">
        <div class="flex flex-col gap-3 border-b border-border bg-surface-sunken p-4 md:flex-row md:items-center md:justify-between md:px-6">
            <div class="flex items-center gap-4">
                <SetupCalendarTile class="size-12 overflow-hidden rounded-lgr" />
                <div class="min-w-0">
                    <h2 class="display-small-serif">Calendar Intelligence</h2>
                    <p class="body mt-1 text-ink-muted">Get insights before and after your key meetings.</p>
                </div>
            </div>
            <BaseButton theme="primary" class="shrink-0 self-center bg-accent hover:bg-accent-hover" @click="handleConnect">Connect calendar</BaseButton>
        </div>

        <div class="relative px-4 py-3 md:px-6">
            <BaseCard padding="none" class="divide-y divide-border px-3" aria-hidden="true" inert>
                <div v-for="event in previewEvents" :key="event.start" class="flex h-16 items-center gap-3 px-2 md:gap-6">
                    <div class="scaffold-body-small w-10 shrink-0 text-ink-muted">
                        <p>{{ event.start }}</p>
                        <p>{{ event.end }}</p>
                    </div>
                    <div class="min-w-0 flex-1 opacity-50 blur-xs">
                        <p class="body-semibold truncate">{{ event.title }}</p>
                        <p class="body-small truncate text-ink-muted">{{ event.attendees }}</p>
                    </div>
                    <BaseButton theme="neutral" size="sm" class="inline-flex shrink-0 items-center gap-2 bg-surface-raised opacity-50">
                        <i v-if="event.action === 'Insights'" class="bi bi-lightbulb" aria-hidden="true"></i>
                        {{ event.action }}
                    </BaseButton>
                </div>
            </BaseCard>
            <div class="pointer-events-none absolute inset-0 flex items-center justify-center">
                <BaseButton
                    theme="neutral"
                    icon-only
                    aria-label="Connect calendar to unlock Calendar Intelligence"
                    class="group pointer-events-auto size-20 rounded-full border-0 bg-surface-raised text-ink-muted shadow-lg"
                    @click="handleConnect">
                    <i class="bi bi-lock-fill flex scale-80 items-center justify-center text-4xl leading-none group-hover:hidden group-focus-visible:hidden" aria-hidden="true"></i>
                    <i class="bi bi-unlock-fill hidden scale-80 items-center justify-center text-4xl leading-none group-hover:flex group-focus-visible:flex" aria-hidden="true"></i>
                </BaseButton>
            </div>
        </div>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import SetupCalendarTile from "~vue/icons/SetupCalendarTile.vue";
import { returnToCalendarAfterConnect, useCalendarStore } from "~vue/stores/calendarStore";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { onMounted } from "vue";

const previewEvents = [
    { start: "9:00", end: "10:30", title: "Eva / Aidan 1:1", attendees: "Aidan Malone", action: "Debrief" },
    { start: "13:00", end: "14:00", title: "Design review for Align data", attendees: "12 attendees", action: "Prepare" },
    { start: "15:00", end: "16:15", title: "Feedback and direction", attendees: "9 attendees", action: "Insights" },
];

onMounted(() => logUserInteraction(AmplitudeEventNames.CALENDAR_INTEGRATION_CARD_SHOWN, { variant: "locked_preview" }));

const handleConnect = () => {
    returnToCalendarAfterConnect.value = true;
    useCalendarStore.openConnectCalendarDialog("calendar_locked_preview");
};
</script>
